export const config = {
    apiUrl: '/api',
};
